/**
 * @description Установить токен сервиса уведомлений.
 * @type {string}
 */
export const SERVER_MESSAGES_SET_TOKEN = 'SERVER_MESSAGES_SET_TOKEN';

/**
 * @description Сбросить аутентификацию сервиса уведомлений.
 * @type {string}
 */
export const SERVER_MESSAGES_LOGOUT = 'SERVER_MESSAGES_LOGOUT';

export default SERVER_MESSAGES_SET_TOKEN;
